export default __webpack_public_path__ + "static/media/votacao-ao-vivo.6dd54e83.png";